export default __webpack_public_path__ + "images/metamask_b6b09b.svg";